import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class ProdutoModel {

  public field: any = {

    seqipd: <string>'',
    numped: <string>'',

    codpro: <string>'CHPGBRD20J',
    despro: <string>'CHPGBRD20J - CHAPA POLIDA DE GRANITO BRANCO DALLAS',

    codder: <string>'020',
    desder: <string>'020 - 2,0 CM',

    coddep: <string>'DEPCAJ1',
    desdep: <string>'DEPCAJ1 - DEPÓSITO DE CHAPAS',

    qtdped: <string>'10',
    preuni: <string>'1,23',
    vlrdsc: <string>'',
    usuvlrfre: <string>'',
    qtdchp: <string>'1',
    percom: <string>'',

    tnspro: <string>'90100',
    unimed: <string>'M2',

    valtotitem: <string>'',

  };

  constructor(public formBuilder: FormBuilder) {
    this.resetForm(true);
  }

  resetForm(resetAll) {
    for (let prop in this.field) {
      if (resetAll) {
        eval("this.field." + prop + " = '' ");
      } else {
        if (prop != 'codpro' && prop != 'despro') {
          eval("this.field." + prop + " = '' ");
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/model/produto.model.ts